module.exports = __webpack_public_path__ + "img/banner2.580ad63f.png";